// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/atc-circuit-sequencing-instructions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/atc-circuit-sequencing-instructions/atc-circuit-sequencing-instructions.js';

mount([g0]);
